export default __webpack_public_path__ + "static/andreik-1c9c6b597a46b8a83651f5e46c806a8c.png";